import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";

import { getGhaInfo } from '../../../store/actions/ghaAction';
import { receiveError, receiveSuccess } from "../../../store/actions/notificationAction";

import offlineRfsRemote from '../../../api/offlineRfsRemote';
import attachmentsRequestHandler from '../../../api/attachmentsRemote';
import ManageRfsSetup from "./ManageRfsSetup";

import ApiResponse from "../../../models/ApiResponse";
import ResponseError from "../../../models/ResponseError";
import { UserRoleType } from "../../../models/User";
import User from "../../../models/User";
import OrderSearchOptions from '../../../models/OrderSearchOptions';
import OrderDashboard from '../../../models/OrderDashboard';
import GhaModel from '../../../models/Gha';
import { CurrentAwb, OfflineRfsOrder, TruckingCompany } from '../../../models/OfflineRfs';

import { SEARCH_OPTIONS_SCHEMA } from '../../../utils/searchOptions';
import { PO_SCHEMA } from '../../../utils/offlineOrder';
import AttachmentsContainer from "../../attachments/AttachmentsContainer";
import moment, { Moment } from "moment";
import ConfirmationDialog from '../../confirmation/ConfirmationDialog';
import TruckInfo from "./TruckInfo";
import signatureRequestHandler from "../../../api/signatureRemote";
import ManifestInfo from './ManifestInfo';
import AddTruckingCompany from "./AddTruckingCompany";
import AwbsTable from "./AwbsTable";
import OrderAttachmentsContainer from "../../orderAttachments/OrderAttachmentsContainer";
import ManageUnrecognizedDocContainer from '../../common/unrecognizedDocuments/ManageUnrecognizedDocContainer';

import RfsStyles from '../rfs.module.css';
import commonStyles from '../../common/common.module.css';
import { Close } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import { baseUrl } from "../../../api/baseUrl";

const PREFIX_PHONE_NUMBER: string = '+1';

interface ManageRfsContainerProps {
  history: any;
  user: User;
  userRole: UserRoleType;
  receiveSuccess: Function;
  receiveError: Function;
  getGhaInfo: Function;
  gha: GhaModel;
}

interface ManageRfsSetupState {
  isModalOpen: boolean;
  isAttachmentsDialogOpen: boolean;
  isInitialOrderListed: boolean;
  startDate: Moment;
  endDate: Moment;
  startTime: Moment;
  code: string;
  number: string;
  endTime: Moment;
  searchOptions: OrderSearchOptions;
  pos: Array<OrderDashboard>;
  selectedOrderNumber: number;
  orderInfo: OfflineRfsOrder;
  offlineAwbs: Array<CurrentAwb>;
  openConfirmationDialog: boolean;
  deleteOrderNumber: number;
  awbsOrderNumber?: number;
  attachmentOrderNumber: number;
  doo: OfflineRfsOrder;
  isManifestDialogOpen: boolean;
  isTcModalOpen: boolean;
  truckerCompany: TruckingCompany;
  truckersCompanyList: Array<TruckingCompany>;
  ghaOrigin: string;
  view: string;
  savedSignatureUrl: string;
  openFinalizeConfirmationDialog: boolean;
  awbModal: boolean;
  isOrderAttachmentsDialogOpen: boolean;
  orderNumber: string;
  mvt: string;
  displayUnrecognizedDocs: boolean;
  countUnrecognizedDocs: number;
  version: number;
}

class ManageRfsContainer extends PureComponent<ManageRfsContainerProps, ManageRfsSetupState> {
  state: ManageRfsSetupState = {
    isModalOpen: false,
    isAttachmentsDialogOpen: false,
    isInitialOrderListed: false,
    startDate: moment(),
    endDate: moment(),
    startTime: moment("2000-01-01 00:00"),
    endTime: moment("2000-01-01 23:59"),
    searchOptions: SEARCH_OPTIONS_SCHEMA,
    pos: [],
    selectedOrderNumber: 0,
    orderInfo: PO_SCHEMA,
    openConfirmationDialog: false,
    deleteOrderNumber: -1,
    awbsOrderNumber: -1,
    attachmentOrderNumber: -1,
    doo: PO_SCHEMA,
    offlineAwbs: [],
    code: '',
    number: '',
    version: 0,
    isManifestDialogOpen: false,
    isTcModalOpen: false,
    truckerCompany: {
      name: '',
      email: ''
    },
    truckersCompanyList: [],
    ghaOrigin: '',
    view: 'render',
    savedSignatureUrl: '',
    openFinalizeConfirmationDialog: false,
    awbModal: false,
    isOrderAttachmentsDialogOpen: false,
    orderNumber: '',
    mvt: 'arr',
    displayUnrecognizedDocs: false,
    countUnrecognizedDocs: 0
  };

  componentDidMount(): void {

    this.props.getGhaInfo(this.props.user.gha_id);
    this.doGetOfflineRfsOrdersRequest(true);

    this.getTruckerCompanies();

    this.loadUnrecognizedDocs();
  }

  componentDidUpdate(prevProps: ManageRfsContainerProps): void {

    const orderList =  { ...this.state.pos };
    if(Object.keys(orderList).length==0 && this.props.gha.id>0 && !this.state.isInitialOrderListed) {
      this.setState ({ isInitialOrderListed:true });
      this.doGetOfflineRfsOrdersRequest(true);
    }
  }

  getTruckerCompanies = (): void => {

    offlineRfsRemote.getTruckerCompany().then((resp: ApiResponse<Array<TruckingCompany>>) => {

      const truckersCompanyList: Array<TruckingCompany> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (truckersCompanyList) {
        this.setState({ truckersCompanyList });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  isFinalised = (): void => {

    const orderInfo: OfflineRfsOrder = { ...this.state.orderInfo };
    if(orderInfo.driver_name && orderInfo.driver_id && orderInfo.sta && orderInfo.driver_contact && orderInfo.driver_vehichle_registration && orderInfo.id_delivery_company && (orderInfo.locked || (orderInfo.sealed && orderInfo.seal_number))) {
      orderInfo.is_finalised = true
    } else {
      orderInfo.is_finalised = false
    }
    this.setState ({ orderInfo });
  }

  openDialog = (type: string, id?: number, orderNumber?: string): void => {

    switch (type) {
      case 'ManifestDetails':
        this.setState({ isManifestDialogOpen: true });
        if(id) {

          const dooNumber: number = id;

          offlineRfsRemote.getOfflineRfsOrderDetails(dooNumber).then((resp: ApiResponse<OfflineRfsOrder>) => {

            const doo: OfflineRfsOrder | undefined = resp.result;
            const error: ResponseError | undefined = resp.error;

            if (doo) {
              const savedSignatureUrl: string = signatureRequestHandler.constructOfflineSignatureUrl(dooNumber, {
                code: '', number: ''
              });
              const dropOffOrder: OfflineRfsOrder = { ...doo };
              dropOffOrder.pickup_time = doo.latest_eta;

              this.setState({ doo: dropOffOrder, savedSignatureUrl });

            }

            if (error) {
              this.props.receiveError(error);
            };
          });
        }
        break;
      case 'TcModal':
        this.setState({ isTcModalOpen: true });
        break;
      case 'viewAwbs':
        this.setState({ awbModal: true, awbsOrderNumber: id });
        break;
      case 'attachments':
        this.setState({ isOrderAttachmentsDialogOpen: true, attachmentOrderNumber: id ? id : -1, orderNumber: orderNumber ? orderNumber: '' });
        break;
      default: break;
    }
  }

  closeDialog = (type: string): void => {

    switch (type) {
      case 'ManifestDetails':
        this.setState({ isManifestDialogOpen: false });
        break;
      case 'TcModal':
        this.setState({ isTcModalOpen: false });
        break;
      case 'viewAwbs':
        this.setState({ awbModal: false });
        break;
      default: break;
    }
  }

  printAwbInfoClicked = (awb: string, version: number) => {
    const awbNumberArr: string[] = awb.split('-');
    let url: string = `${baseUrl}pickup_order/offline_rfs/awb/${awbNumberArr[0]}/${awbNumberArr[1]}/${version}/file`;

    window.open(url);
  }

  doGetOfflineRfsOrdersRequest = (doSort: boolean): void => {

    let searchOptions: OrderSearchOptions = { ...this.state.searchOptions };
    let startDate: string = (this.state.startDate) ? this.state.startDate.format('YYYYMMDD') : searchOptions.startDate.format('YYYYMMDD');
    let endDate: string = (this.state.endDate) ? this.state.endDate.format('YYYYMMDD') : searchOptions.endDate.format('YYYYMMDD');
    let startTime: string = (this.state.startTime) ? this.state.startTime.format('HHmm') : moment().format('HHmm');
    let endTime: string = (this.state.endTime) ? this.state.endTime.format('HHmm') : moment().format('HHmm');
    let origin: string = this.props.gha.info.location ? this.props.gha.info.location : '';

    if (searchOptions.ignoreDateAndTime && searchOptions.ignoreDateAndTime === true) {
      startDate = '';
      endDate = '';
      startTime = '';
      endTime = '';
    }

    offlineRfsRemote.getOfflineRfsOrders(startDate, endDate, startTime, endTime, searchOptions.keyword, origin, this.state.mvt, doSort).then((resp: ApiResponse<Array<OrderDashboard>>) => {

      const pos: Array<OrderDashboard> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (pos) {
        this.setState({ pos, selectedOrderNumber:0, ghaOrigin:origin });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  handleChangeDate = (type: string, date: Moment): void => {

    const orderInfo: OfflineRfsOrder = { ...this.state.orderInfo };

    switch (type) {
      case "fromDate":
        this.setState({ startDate: date });
        break;
      case "toDate":
        this.setState({ endDate: date });
        break;
      case "departureDate":
        orderInfo.departure_date =  date.format('YYYYMMDD');
        this.setState ({ orderInfo });
        break;
      case "arrivalDate":
        orderInfo.arrival_date =  date.format('YYYYMMDD');
        this.setState ({ orderInfo });
        break;
      default:
        break;
    }
  };

  handleChangeTime = (type: string, date: Moment): void => {

    const orderInfo: OfflineRfsOrder = { ...this.state.orderInfo };

    switch (type) {
      case "fromTime":
        this.setState({ startTime: date });
        break;
      case "toTime":
        this.setState({ endTime: date });
        break;
      case "departureTime":
        orderInfo.departure_time =  date.format('HHmm');
        this.setState ({ orderInfo });
        break;
      case "arrivalTime":
        orderInfo.arrival_time =  date.format('HHmm');
        this.setState ({ orderInfo });
        break;
      default:
        break;
    }
  };

  handleFilter = (): void => {

    this.doGetOfflineRfsOrdersRequest(true)
  }

  printPdf = (id?: number): void => {
    let url: string = `${baseUrl}offlinerfs_order/${id}/file`;

    window.open(url);
  }

  handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>, id: number): void => {

    const selectedOrderNumber: number = id;
    if(this.state.selectedOrderNumber !== selectedOrderNumber) {
      this.setState({
        selectedOrderNumber,
        orderInfo: PO_SCHEMA
      });
      this.loadDropOffOrderAwbs(selectedOrderNumber);
    }
  }

  loadDropOffOrderAwbs = (orderId: number): void => {

    offlineRfsRemote.getOfflineRfsOrderDetails(orderId).then((resp: ApiResponse<OfflineRfsOrder>) => {

      const orderInfo: OfflineRfsOrder | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (orderInfo) {
        orderInfo.maskedDriverId = (orderInfo.driver_id) ? orderInfo.driver_id.replace(/.(?=.{4,}$)/g, '#') : '';
        orderInfo.driver_contact = (orderInfo.driver_contact) ? orderInfo.driver_contact.replace('+1', '') : '';
        this.setState({ orderInfo });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  openAttachments = (awb: string, version?: number): void => {

    const awbNumberArr: string[] = awb.split('-');
    this.setState({ code: awbNumberArr[0], number: awbNumberArr[1], version: version || 0 }, () => {
      this.setState({ isAttachmentsDialogOpen: true });
    });
  };

  closeAttachments = (): void => {

    this.setState({ isAttachmentsDialogOpen: false, attachmentOrderNumber: -1 });
  };

  closeOrderAttachments = (): void => {

    this.setState({ isOrderAttachmentsDialogOpen: false, attachmentOrderNumber: -1 });
  };

  createRfsHandler = (): void => {

    this.props.history.push('/create-rfs/' );
  }

  handleChange = (name: string, event: any): void => {

    const orderInfo: OfflineRfsOrder = { ...this.state.orderInfo };
    const truckerCompany: TruckingCompany = { ...this.state.truckerCompany };

    switch(name) {
      case 'driverName':
        orderInfo.driver_name =  event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'driverLicence':
        orderInfo.driver_id =  event.target.value;
        orderInfo.maskedDriverId = event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'hazmat':
        const hazmat: boolean = !this.state.orderInfo.hazmat;
        orderInfo.hazmat =  hazmat;
        this.setState ({ orderInfo });
      break;
      case 'sta':
        orderInfo.sta =  event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'driverContact':
        orderInfo.driver_contact =  event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'truckPlate':
        orderInfo.driver_vehichle_registration =  event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'sealed':
        if (this.state.orderInfo.locked) {
          orderInfo.locked = false;
          orderInfo.seal_number= '';
        }

        const sealed: boolean = !this.state.orderInfo.sealed;
        orderInfo.sealed =  sealed;
        this.setState ({ orderInfo });
      break;
      case 'locked':
        if ( this.state.orderInfo.sealed ) {
          orderInfo.sealed = false;
          orderInfo.seal_number= '';
        }

        const locked: boolean = !this.state.orderInfo.locked;
        orderInfo.locked =  locked;
        this.setState ({ orderInfo });
      break;
      case 'sealNumber':
        orderInfo.seal_number =  event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'companyName':
        orderInfo.id_delivery_company = event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'billRef':
        orderInfo.bill_to.full_address = event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'org_remarks':
        orderInfo.org_comment = event.target.value;
        this.setState ({ orderInfo });
      break;
      case 'dst_remarks':
        orderInfo.dst_comment = event.target.value;
        this.setState ({ orderInfo });
      break;

      case 'truckerName':
        truckerCompany.name = event.target.value;
        this.setState ({ truckerCompany });
      break;

      case 'truckerEmail':
        truckerCompany.email = event.target.value;
        this.setState ({ truckerCompany });
      break;
      case 'mvt':
        this.setState ({ mvt: event.target.value }, () => {
          this.doGetOfflineRfsOrdersRequest(true);
        });
      break;

      default: break;
    }
  }

  handleUpdate = async (type: string): Promise<void> => {

    const orderInfo: OfflineRfsOrder = { ...this.state.orderInfo };
    orderInfo.driver_contact =  (orderInfo.driver_contact) && !orderInfo.driver_contact.includes(PREFIX_PHONE_NUMBER) ? PREFIX_PHONE_NUMBER + orderInfo.driver_contact : orderInfo.driver_contact;
    if(type === 'final') {
      orderInfo.is_finalised = true;
    }
    this.setState ({ orderInfo });

    offlineRfsRemote.updateOfflineRfsOrder(orderInfo).then((resp: ApiResponse<boolean>) => {

      const updated: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (updated) {
        this.setState ({
          selectedOrderNumber: 0,
          orderInfo: PO_SCHEMA,
          openFinalizeConfirmationDialog: false
        });
        this.doGetOfflineRfsOrdersRequest(true);
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleTruckingCompany = async (): Promise<void> => {

    const truckerCompany: TruckingCompany = { ...this.state.truckerCompany };

    offlineRfsRemote.createTruckerCompany(truckerCompany).then((resp: ApiResponse<{ id: number }>) => {

      const updated: { id: number } | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (updated) {
        const orderInfo: OfflineRfsOrder = { ...this.state.orderInfo };
        orderInfo.id_delivery_company =  updated.id;
        this.setState ({ orderInfo });
        this.closeDialog("TcModal");
        this.getTruckerCompanies();
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  closeConfirmationDialog = (): void => {

    this.setState({ openConfirmationDialog: false, deleteOrderNumber: -1 });
  }

  handleDelete = async (id: number): Promise<void> => {

    this.setState({ deleteOrderNumber: id, openConfirmationDialog: true });
  }

  handleFinalize = async (): Promise<void> => {

    this.setState({ openFinalizeConfirmationDialog: true });
  }

  deleteOfflineOrder = (): void => {

     offlineRfsRemote.deleteOfflineOrder(this.state.deleteOrderNumber).then((resp: ApiResponse<boolean>) => {

      const updated: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (updated) {
        this.closeConfirmationDialog();
        this.doGetOfflineRfsOrdersRequest(true);
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  maskon = () => {

    const orderInfo: OfflineRfsOrder = { ...this.state.orderInfo };
    orderInfo.maskedDriverId =  (orderInfo.driver_id) ? orderInfo.driver_id.replace(/.(?=.{4,}$)/g, '#') : '';
    this.setState ({ orderInfo });
  }

  handleClick = (event: any) => {

    const key: string = event.target.id;
    if(key === 'driverLicence') {
      const orderInfo: OfflineRfsOrder = { ...this.state.orderInfo };
      orderInfo.maskedDriverId = orderInfo.driver_id;
      this.setState({ orderInfo });
    }
  }

  handleEdit = async (id: number): Promise<void> => {

    this.props.history.push(`/create-rfs/${id}` );
  }

  handleShowUnrecognizedDocs = (): void  => {
    this.setState({ displayUnrecognizedDocs: true });
  }

  handleHideUnrecognizedDocs = (): void => {
    this.setState({ displayUnrecognizedDocs: false });
    this.loadUnrecognizedDocs();
  }

  loadUnrecognizedDocs = (): void => {
    attachmentsRequestHandler.loadUnrecognizedAttachments().then((resp: ApiResponse<Array<any>>) => {
      const result: Array<any> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({ countUnrecognizedDocs: result.length })
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render() {
    return (
      <Fragment>
        <div className= { commonStyles.headerDummyDiv }> </div>
        <div className={ this.state.displayUnrecognizedDocs ? RfsStyles.hide : RfsStyles.show } >
          { !this.state.isManifestDialogOpen &&
            <ManageRfsSetup
              userId={ this.props.user.roleId }
              fromDate={ this.state.startDate }
              toDate={ this.state.endDate }
              fromTime={ this.state.startTime }
              toTime={this.state.endTime}
              handleChangeDate={ this.handleChangeDate }
              handleChangeTime={ this.handleChangeTime }
              ordersList={ this.state.pos }
              handlefilter={ this.handleFilter }
              handleNumberChange={ this.handleNumberChange }
              selectedNumber={ this.state.selectedOrderNumber }
              handleCreateRfs={ this.createRfsHandler }
              handleChange={ this.handleChange }
              onClick={ this.handleClick }
              handleDelete={ this.handleDelete }
              handleEdit={ this.handleEdit }
              openDialog={ this.openDialog }
              isTcModalOpen= {this.state.isTcModalOpen}
              ghaOrigin={ this.props.gha.info.location }
              mvt={ this.state.mvt }
              handleShowUnrecognizedDocs={ this.handleShowUnrecognizedDocs }
              displayUnrecognizedDocs={ this.state.displayUnrecognizedDocs }
              countUnrecognizedDocs={ this.state.countUnrecognizedDocs }
            />
          }
          { this.state.isManifestDialogOpen &&
            <ManifestInfo
              printContent={ this.printPdf }
              onClick={ this.handleClick }
              closeDialog={ this.closeDialog }
              doo={this.state.doo}
              view={ this.state.view }
              savedSignatureUrl={ this.state.savedSignatureUrl }
            />
          }
          { !this.state.isManifestDialogOpen && this.state.selectedOrderNumber > 0 &&
            <TruckInfo
              truckersCompanyList={ this.state.truckersCompanyList }
              handleChangeDate={this.handleChangeDate}
              handleChangeTime={this.handleChangeTime}
              openDialog={ this.openDialog }
              ghaOrigin={ this.props.gha.info.location }
              orderInfo={ this.state.orderInfo }
              maskon={ this.maskon }
              onClick={ this.handleClick }
              prefixPhoneNumber={ PREFIX_PHONE_NUMBER }
              handleChange={ this.handleChange }
              handleUpdate={ this.handleUpdate }
              handleFinalize={ this.handleFinalize }
            />
          }
          { this.state.isAttachmentsDialogOpen &&
            <AttachmentsContainer
              code={ this.state.code }
              number={ this.state.number }
              process={ "export" }
              closeAttachments={ this.closeAttachments }
              refreshAwbs={ true }
              rfs={ true }
              version={ this.state.version }
            />
          }
          { this.state.isOrderAttachmentsDialogOpen &&
            <OrderAttachmentsContainer
              orderId={ this.state.attachmentOrderNumber }
              number={ this.state.orderNumber }
              process={ "export" }
              closeAttachments={ this.closeOrderAttachments }
              refreshAwbs={ true }
              type={ 'rfs' }
            />
          }
          { this.state.openConfirmationDialog &&
            <ConfirmationDialog
              open={ this.state.openConfirmationDialog }
              close={ this.closeConfirmationDialog }
              title='Delete Confirmation'
              text='This item will be permanently removed. To confirm deletion click on the “Delete” button.'
              textConfirm='delete'
              confirm={ this.deleteOfflineOrder }
              showCloseIcon={ true }
            />
          }
          { this.state.openFinalizeConfirmationDialog &&
            <ConfirmationDialog
              open={ this.state.openFinalizeConfirmationDialog }
              close={ () => { this.setState({ openFinalizeConfirmationDialog: false }) } }
              title='Finalize Confirmation'
              text='Are you sure you want to finalize this order?'
              textConfirm='Finalize'
              confirm={ () => this.handleUpdate('final') }
              showCloseIcon={ true }
            />
          }
          { this.state.isTcModalOpen &&
            <AddTruckingCompany
              handleTruckingCompany={ this.handleTruckingCompany }
              truckerInfo={ this.state.truckerCompany }
              closeDialog={ this.closeDialog }
              handleChange={ this.handleChange }
            />
          }
          { this.state.awbModal &&
            <AwbsTable
              handleClose={ this.closeDialog }
              openAttachments={ this.openAttachments }
              printAwbInfoClicked={ this.printAwbInfoClicked }
              modalOpen={ this.state.awbModal }
              selectedOrderNumber={ this.state.awbsOrderNumber }
            />
          }
        </div>
        <div className={ !this.state.displayUnrecognizedDocs ? RfsStyles.hide : RfsStyles.show } >
          <div className={ RfsStyles.unrecognizedDocModal }>
            <IconButton aria-label="Close" className={ RfsStyles.unrecognizedDocBtn } onClick={ this.handleHideUnrecognizedDocs }>
              <Close color="primary" />
            </IconButton>
            <ManageUnrecognizedDocContainer
              displayUnrecognizedDocs={ this.state.displayUnrecognizedDocs }
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    gha: state.ghaInfo
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
    getGhaInfo: (ghaId: number) => dispatch(getGhaInfo(ghaId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageRfsContainer);
